export default "/packs/images/ta-new~078bf314e8b9c882d3b1521576f5e619.png";